// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.crit-background{border:1px solid var(--sakai-border-color);border-radius:6px;background-color:var(--sakai-background-color-2);max-width:1080px}.descr{width:100%}.points{max-width:70px;margin-left:25px}.select-btn{padding:5px 10px;margin:5px;font-size:medium}.remove-btn{margin-left:2px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
